// components/ScrollReveal.jsx
import { useEffect } from 'react';

const ScrollReveal = () => {
    useEffect(() => {
        // Function to check if element is in viewport
        const reveal = () => {
            const reveals = document.querySelectorAll(
                '.reveal, .reveal-left, .reveal-right, .reveal-fade, .reveal-scale'
            );

            for (let i = 0; i < reveals.length; i++) {
                const windowHeight = window.innerHeight;
                const elementTop = reveals[i].getBoundingClientRect().top;
                const elementVisible = 150; // Adjust this value to change when the animation triggers

                if (elementTop < windowHeight - elementVisible) {
                    reveals[i].classList.add('active');
                } else {
                    // Optional: remove the active class when scrolling back up
                    // reveals[i].classList.remove('active');
                }
            }
        };

        // Add event listener
        window.addEventListener('scroll', reveal);

        // Call reveal function on component mount to check for elements already in viewport
        reveal();

        // Clean up
        return () => {
            window.removeEventListener('scroll', reveal);
        };
    }, []);

    return null; // This component doesn't render anything
};

export default ScrollReveal;